// extracted by mini-css-extract-plugin
export default {"root":"style-module__root____vHnO","root__price":"style-module__root__price___Vn3a2","root__price_text":"style-module__root__price_text___tlFxG","root__price_icon":"style-module__root__price_icon___kGdzV"};
    if(module.hot) {
      // 1697460474735
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  